interface BottomNavProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  onCenterAction?: () => void;
}

const tabs = [
  { id: 'inicio', label: 'Inicio', icon: 'ri-home-5-line', iconActive: 'ri-home-5-fill' },
  { id: 'familia', label: 'Familia', icon: 'ri-team-line', iconActive: 'ri-team-fill' },
  { id: 'pagos', label: 'Pagos', icon: 'ri-bank-card-line', iconActive: 'ri-bank-card-fill' },
  { id: 'plan', label: 'Tu plan', icon: 'ri-shield-line', iconActive: 'ri-shield-fill' },
];

export default function BottomNav({ activeTab, onTabChange, onCenterAction }: BottomNavProps) {
  const leftTabs = tabs.slice(0, 2);
  const rightTabs = tabs.slice(2);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-[#E8E8EF] bg-white" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <div className="mx-auto grid h-20 max-w-md grid-cols-5 items-center px-2">
        {leftTabs.map((tab) => (
          <NavButton key={tab.id} tab={tab} active={activeTab === tab.id} onClick={() => onTabChange(tab.id)} />
        ))}

        <button
          onClick={onCenterAction}
          className="-mt-5 flex flex-col items-center justify-center gap-1"
          aria-label="Agregar beneficiario"
        >
          <span className="flex h-13 w-13 items-center justify-center rounded-full bg-[#2254F4] text-white shadow-lg shadow-[#2254F4]/25 ring-8 ring-white" style={{ width: 52, height: 52 }}>
            <i className="ri-add-line text-3xl" />
          </span>
          <span className="text-[11px] font-semibold text-[#66636D]">Agregar</span>
        </button>

        {rightTabs.map((tab) => (
          <NavButton key={tab.id} tab={tab} active={activeTab === tab.id} onClick={() => onTabChange(tab.id)} />
        ))}
      </div>
    </nav>
  );
}

function NavButton({
  tab,
  active,
  onClick,
}: {
  tab: { id: string; label: string; icon: string; iconActive: string };
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button onClick={onClick} className="flex min-w-0 flex-col items-center justify-center gap-1">
      <span className="flex h-8 w-8 items-center justify-center">
        <i className={`${active ? tab.iconActive : tab.icon} text-[1.45rem]`} style={{ color: active ? '#2254F4' : '#13234A' }} />
      </span>
      <span className="max-w-full text-center text-[11px] font-semibold leading-tight text-[#66636D]">
        {tab.label}
      </span>
    </button>
  );
}
